import { useMutation } from 'react-query';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { ICreateCustomer } from '~/Models/DTO/Customer.model';

export const useRequestCreateCustomer = () =>
  useMutation(async (customer: ICreateCustomer) => {
    const response = await requestReactQuery<any>({
      url: CORE_SERVICE_URLS.CREATE_CUSTOMER,
      data: customer,
      config: { method: 'POST' },
    });

    return response;
  });
